export default __webpack_public_path__ + "static/media/shift.a13a0f8b.wav";